/*
  Application Login Page
  Selects the login experience based on the domain:
    - TOG domain (advance.transova.com) -> TransovaLogin
    - Everything else (Vytelle / Sense)  -> VytelleLogin
*/

import React from "react";

// Components
import VytelleLogin from "./VytelleLogin";
import TransovaLogin from "./TransovaLogin";

// Helper
import { isTogDomain } from "@Vytelle/authentication/src/helpers/DomainHelper";

function Login() {
  return isTogDomain() ? <TransovaLogin /> : <VytelleLogin />;
}

export default Login;
